import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: BASE });
export const STYLIST_URL = `${BASE}/ai/stylist`;

export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data.products);
export const getProduct = (handle) => api.get(`/products/${handle}`).then((r) => r.data);
export const getCollections = () => api.get("/collections").then((r) => r.data.collections);
export const getRecommendations = (body) => api.post("/recommendations", body).then((r) => r.data.products);
export const getPairings = (handle) => api.get(`/pairings/${handle}`).then((r) => r.data.products);
export const postCheckout = (body) => api.post("/checkout", body).then((r) => r.data);
export const postSizeFinder = (body) => api.post("/size-finder", body).then((r) => r.data);
export const getLoyalty = (guestId) => api.get(`/loyalty/${guestId}`).then((r) => r.data);
export const earnLoyalty = (body) => api.post("/loyalty/earn", body).then((r) => r.data);
export const redeemLoyalty = (body) => api.post("/loyalty/redeem", body).then((r) => r.data);
export const captureEmail = (body) => api.post("/email/capture", body).then((r) => r.data);
export const trackEvent = (body) => api.post("/track", body).catch(() => {});

export const money = (n) => `$${Number(n).toFixed(2)}`;
